import React from 'react';
import '../../cards.css';
import { Badge, Label } from '@nooz-optics/nooz-components-lib';
import { Image } from '../../../Media/Image/index';
import { IImage, ILabel } from '../../../../../utils/types/contentful';
import { Video } from '../../../Media';
import { Link } from '../../../Elements/Link';

export interface CollectionHorizontalUspHighlightCardProps {
  badges?: any;
  label: ILabel;
  subLabel?: ILabel;
  image: IImage;
}

export const CollectionHorizontalUspHighlightCard = ({
  badges,
  label,
  subLabel,
  image,
  video,
  color,
  button,
}: CollectionHorizontalUspHighlightCardProps) => {
  const hasSlug = button?.slug;

  const returnCollectionHorizontalUspHighlightCard = () => (
    <div
      className='cards w-full  h-full relative'
      style={{ 'grid-column-start': 1, 'grid-column-end': 3 }}>
      <div className='absolute top-0 h-full w-full' />
      <div
        className='absolute bg-opacity-0 h-full w-full bg-black backdrop-filter'
        aria-hidden='true'
      />
      <div className='absolute w-full h-full p-5'>
        <div className='relative flex flex-col justify-between h-full'>
          <div className='flex flex-wrap'>
            {badges &&
              badges?.items?.map((badge) => (
                <div className='mr-2 mb-2'>
                  <Badge {...badge} />
                </div>
              ))}
          </div>
          <Label
            {...label}
            size='5xl'
            weight='medium'
          />
          {subLabel ? (
            <div className='mb-2'>
              <Label
                {...subLabel}
                family='font-inter'
                weight='light'
              />
            </div>
          ) : (
            <div />
          )}
        </div>
      </div>
      <div className='absolute -z-1 w-full h-full'>
        <div className='h-1/2 w-full '>
          {image && (
            <Image
              {...image}
              bgColor='gray-200'
              objectFit='cover'
              height='100%'
              width='100%'
            />
          )}
          {video && (
            <Video
              {...video}
              height='100%'
              width='100%'
            />
          )}
        </div>
        <div className={`h-1/2 w-full bg-${color?.classname}`} />
      </div>
    </div>
  );

  const returnCollectionHorizontalUspHighlightWithLinkCard = () => (
    <Link slug={hasSlug}>{returnCollectionHorizontalUspHighlightCard()}</Link>
  );
  return (
    <>
      {hasSlug
        ? returnCollectionHorizontalUspHighlightWithLinkCard()
        : returnCollectionHorizontalUspHighlightCard()}
    </>
  );
};
